import React from 'react';
import PropTypes from 'prop-types';

const Notification = ({ colour, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width="35"
    height="39"
    viewBox="0 0 35 39"
    {...props}>
    <defs>
      <path
        id="notification-a"
        d="M155.52 1425.778a10.138 10.138 0 00-2.263 3.682 15.418 15.418 0 00-6.198 12.37c0 4.264 1.728 8.124 4.522 10.919 2.795 2.794 6.655-.625 10.919-.625s8.124 3.419 10.919.625a15.393 15.393 0 004.522-10.919c0-5.061-2.435-9.554-6.197-12.37a10.13 10.13 0 00-2.26-3.681c6.188 2.696 10.516 8.868 10.516 16.051 0 9.665-7.835 17.5-17.5 17.5s-17.5-7.835-17.5-17.5c0-7.139 4.275-13.28 10.404-16.002zm6.98-4.315c.851 0 1.542.712 1.542 1.587v1.69l.893.295c3.27 1.08 5.532 4.228 5.532 7.827v5.833c0 1.318 1.036 2.385 2.312 2.385.425 0 .773.358.773.796 0 .732-.594 1.325-1.326 1.325h-6.715a3.088 3.088 0 11-6.023 0h-6.714a1.325 1.325 0 01-1.326-1.325c0-.437.348-.796.773-.796 1.275 0 2.312-1.068 2.312-2.385v-5.833c0-3.596 2.263-6.745 5.532-7.827l.893-.295v-1.69c0-.875.692-1.587 1.542-1.587z" // eslint-disable-line max-len
      ></path>
    </defs>
    <use
      fill={colour}
      transform="translate(-145 -1421)"
      xlinkHref="#notification-a"></use>
  </svg>
);

Notification.propTypes = {
  colour: PropTypes.string.isRequired,
};

export default Notification;
